/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-20T19:25:48.994
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentHouseTraffic,
	getRentHouseTrafficCreateInit,
	getRentHouseTrafficEditInit,
	getRentHouseTrafficView,
	deleteRentHouseTraffic
} from '@api/rentmanage/RentHouseTraffic';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentHouseTrafficCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseTrafficCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseTrafficEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseTrafficEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseTraffic({}, RentHouseTraffic) {
			return new Promise((resolve, reject) => {
				saveRentHouseTraffic(RentHouseTraffic)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentHouseTrafficView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseTrafficView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentHouseTraffic({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseTraffic({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
